module.exports = "<div [ngClass]=\"'overlay overlay-content'\" [ngStyle]=\"style\" [class]=\"styleClass\" [style.display]=\"visible ? 'block' : 'none'\"\n    (click)=\"onOverlayClick()\">\n    <div *ngIf=\"showCloseButton\" (click)=\"onCloseClick($event)\">\n        <span class=\"overlay-title\">{{overlayTitle}}</span>\n        <button aria-label=\"Close\" class=\"overlay-close close\" type=\"button\">\n            <clr-icon aria-hidden=\"true\" shape=\"close\"></clr-icon>\n        </button>\n    </div>\n    <div class=\"overlay-content\">\n        <ng-content></ng-content>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/overlay/overlay.html
// module id = aN/s
// module chunks = 0